import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['ratingField'];

  ratingFieldTargetConnected(ratingField) {
    ratingField.addEventListener('click', () => this.updateStars(ratingField));
  }

  // private

  updateStars(selectedRatingField) {
    const selectedValue = selectedRatingField.dataset.value;
    this.ratingFieldTargets.forEach((ratingField) => {
      const icon = ratingField.querySelector('ion-icon');
      if (icon) {
        const filled = ratingField.dataset.value <= selectedValue;
        icon.setAttribute('name', filled ? 'star' : 'star-outline');
      }
    });
  }
}
